import {Pipe, PipeTransform} from '@angular/core';
import {Payment} from "../models/payment/paymentOrder.model";

@Pipe({
	name: 'totalSum'
})
export class TotalSumPipe implements PipeTransform {

	transform(payment: Payment): number {
		if (payment) {
			let total = 0;

			payment.order.invoicePositions.forEach(position => {
				total += (position.nettoPrice * position.amount);
			});

            const vat = payment.order.invoicePositions[0].vat;
            if (vat) {
                total += total * (vat / 100);
            }

			return total;
		} else {
			return 0;
		}
	}

}
